import { render, staticRenderFns } from "./CertificateApplies.vue?vue&type=template&id=3ed0705d&scoped=true&"
import script from "./CertificateApplies.vue?vue&type=script&lang=js&"
export * from "./CertificateApplies.vue?vue&type=script&lang=js&"
import style0 from "./CertificateApplies.vue?vue&type=style&index=0&id=3ed0705d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed0705d",
  null
  
)

export default component.exports